<template>
  <a-card :bordered="false">

    <!-- 左侧面板 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="12">
          <a-col  :md="6" :sm="8" v-if="$store.getters.application.applicationType === 'platform'">
            <a-form-item :label="language['premission.applicationName']">
              <a-select v-model="queryParam.applicationId" allowClear >
                <a-select-option v-for="(application,index) in applicationList" :key="index.toString()" :value="application.id">
                  {{ application.applicationNameLanguage }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item :label="language['sys.dictfunc.dictName']" :labelCol="{span: 6}" :wrapperCol="{span: 14, offset: 1}">
              <a-input :placeholder="language['common.pleaseInput']+language['sys.dictfunc.dictName']" v-model="queryParam.dictName"></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item :label="language['sys.dictfunc.dictCode']" :labelCol="{span: 6}" :wrapperCol="{span: 14, offset: 1}">
              <a-input :placeholder="language['common.pleaseInput']+language['sys.dictfunc.dictCode']" v-model="queryParam.dictCode"></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{language['common.searchButton']}}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{language['common.resetButton']}}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>

      <div class="table-operator" style="border-top: 5px">
        <a-button @click="handleAdd" type="primary" icon="plus" v-has="'dict:add'" >{{language['button.add']}}</a-button>
        <a-button type="primary" icon="download" @click="handleExportXls('DictInfo')" v-has="'dict:download'">{{language['common.exportButton']}}</a-button>
        <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
          <a-button type="primary" icon="import" v-has="'dict:uploadXls'">{{language['common.importButton']}}</a-button>
        </a-upload>
        <a-button type="primary" icon="sync" @click="refleshCache()" v-has="'dict:refreshCache'">{{language['sys.dictfunc.refreshCache']}}</a-button>

        <a-button type="primary" icon="hdd" @click="openDeleteList" v-has="'dict:recycleBin'">{{language['common.recycleBin']}}</a-button>
      </div>

      <a-table
        ref="table"
        rowKey="id"
        size="middle"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        @change="handleTableChange">
        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)" v-has="'dict:edit'" v-if="($store.getters.application.applicationType=='platform'||record.applicationCode==$store.getters.applicationCode)">
            <a-icon type="edit"/>
            {{language['common.edit']}}
          </a>
          <a-divider type="vertical" v-if="($store.getters.application.applicationType=='platform'||record.applicationCode==$store.getters.applicationCode)"/>
          <a @click="editDictItem(record)" v-has="'dict:dictConfig'"><a-icon type="setting"/> {{ language['sys.dictfunc.dictConfig'] }}</a>
          <a-divider type="vertical" v-if="($store.getters.application.applicationType=='platform'||record.applicationCode==$store.getters.applicationCode)"/>
          <a-popconfirm v-has="'dict:delete'" :title="language['common.deleteConfirmInfo']" :okText="language['common.okButton']" :cancelText="language['common.cancel']" @confirm="() =>handleDelete(record.id)"
                        v-if="($store.getters.application.applicationType=='platform'||record.applicationCode==$store.getters.applicationCode)">
            <a>{{language['common.delete']}}</a>
          </a-popconfirm>

        </span>
      </a-table>

    </div>
    <dict-modal ref="modalForm" @ok="modalFormOk"></dict-modal>  <!-- 字典类型 -->
    <dict-item-list ref="dictItemList"></dict-item-list>
    <dict-delete-list ref="dictDeleteList" @refresh="() =>loadData()"></dict-delete-list>
  </a-card>
</template>

<script>
  import { filterObj } from '@/utils/util';
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import DictModal from './modules/DictModal'
  import DictItemList from './DictItemList'
  import DictDeleteList from './DictDeleteList'
  import { getAction,httpAction } from '@/api/manage'
  import { UI_CACHE_DB_DICT_DATA } from "@/store/mutation-types"
  import Vue from 'vue'

  export default {
    name: "DictList",
    mixins:[JeecgListMixin],
    components: {DictModal, DictItemList,DictDeleteList},
    data() {
      return {
        description: '这是数据字典页面',
        visible: false,
        // 查询条件
        queryParam: {
          dictCode: "",
          dictName: "",
          applicationCode:this.$store.getters.application.applicationType=='platform'?'':this.$store.getters.applicationCode,
        },
        // 表头
        //columns: [],
        dict: "",
        labelCol: {
          xs: {span: 8},
          sm: {span: 5},
        },
        wrapperCol: {
          xs: {span: 16},
          sm: {span: 19},
        },
        url: {
          list: "/sys/dict/list",
          delete: "/sys/dict/delete",
          exportXlsUrl: "sys/dict/exportXls",
          importExcelUrl: "sys/dict/importExcel",
          refleshCache: "sys/dict/refleshCache",
          queryAllDictItems: "sys/dict/queryAllDictItems",
        },
        applicationList:[],
      }
    },
    created () {
      if(this.$store.getters.application.applicationType === 'platform') {
        this.getApplicationList();
        //this.loadData();
      }else{
        //this.loadData(1);
      }
    },
    computed: {
      importExcelUrl: function () {
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      language() {
        return this.$store.getters.language
      },
      columns(){
        if(this.language){
          return [
            {
              title: '#',
              dataIndex: '',
              key: 'rowIndex',
              width: 120,
              align: "center",
              customRender: function (t, r, index) {
                return parseInt(index) + 1;
              }
            },
            {
              title: this.language['sys.dictfunc.dictName'],
              align: "left",
              dataIndex: 'dictName',
            },
            {
              title: this.language['sys.dictfunc.dictCode'],
              align: "left",
              dataIndex: 'dictCode',
            },
            {
              title: this.language['common.desc'],
              align: "left",
              dataIndex: 'description',
            },
            {
              title: this.language['common.action'],
              dataIndex: 'action',
              align: "center",
              scopedSlots: {customRender: 'action'},
            }
          ]
        }
      },
    },
    methods: {
      getQueryParams() {
        var param = Object.assign({}, this.queryParam, this.isorter);
        param.field = this.getQueryField();
        param.pageNo = this.ipagination.current;
        param.pageSize = this.ipagination.pageSize;
        if (this.superQueryParams) {
          param['superQueryParams'] = encodeURI(this.superQueryParams)
          param['superQueryMatchType'] = this.superQueryMatchType
        }
        return filterObj(param);
      },
      //取消选择
      cancelDict() {
        this.dict = "";
        this.visible = false;
        this.loadData();
      },
      //编辑字典数据
      editDictItem(record) {
        this.$refs.dictItemList.edit(record);
      },
      // 重置字典类型搜索框的内容
      searchReset() {
        var that = this;
        that.queryParam.dictName = "";
        that.queryParam.dictCode = "";
        that.queryParam.applicationId = "";
        that.queryParam.applicationCode = this.$store.getters.application.applicationType=='platform'?'':this.$store.getters.applicationCode;//this.$store.getters.applicationCode
        that.loadData(this.ipagination.current);
      },
      openDeleteList(){
        this.$refs.dictDeleteList.show()
      },
      refleshCache(){
        getAction(this.url.refleshCache).then((res) => {
          if (res.success) {
            //重新加载缓存
            getAction(this.url.queryAllDictItems).then((res) => {
              if (res.success) {
                Vue.ls.remove(UI_CACHE_DB_DICT_DATA)
                Vue.ls.set(UI_CACHE_DB_DICT_DATA, res.result, 7 * 24 * 60 * 60 * 1000)
              }
            })
            this.$message.success(this.language['sys.dictfunc.refreshSuccess']);
          }
        }).catch(e=>{
          this.$message.warn(this.language['sys.dictfunc.refreshFail']);
          console.log("刷新失败",e)
        })
      },
      getApplicationList(){
        httpAction("/sys/role/getSysBmApplicationDL", "", "get").then((res) => {
          if (res.success) {
            this.applicationList = res.result;
          }
        })
      },
    },
    watch: {
      openKeys(val) {
        console.log('openKeys', val)
      },
    },
  }
</script>
<style scoped>
  @import '~@assets/less/common.less'
</style>